import React,{ memo }  from "react";

import ReactHtmlParser from 'react-html-parser';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
import Meta from "components/Helmet/Meta.jsx";
import AdInFeed from "components/AdSense/AdInFeed.jsx";
import RecommendContentsItem from "components/Contents/RecommendContentsItem.jsx";
// core components
import { useMediaQuery }  from "react-responsive";

//언어 셋팅
import { withTranslation } from "react-i18next";
import i18n from "config/lang/i18n.js";

import sectionTextStyle from "assets/jss/trip-kit/views/blogPostSections/sectionTextStyle.js";


const useStyles = makeStyles(sectionTextStyle);

const SectionText =memo(({currentPath,detailCommon, detailIntro, detailInfos, contentType, recommendTravelList,recommendFoodList,recommendHotelList, lang}) => {
  const isMobile = useMediaQuery({
    query : "(max-width: 930px)"
  })
  const classes = useStyles();

  const metaData = {
    title: detailCommon.title,
    description:detailCommon.overview,
    image:detailCommon.firstimage ==undefined ? "" :  detailCommon.firstimage.replace('http:', 'https:')
  }

  return (
    <div className={classes.section} style={{wordBreak:"break-word"}}>
      <Meta data={metaData} />
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <p style={{ fontWeight:"400"}}>
            {ReactHtmlParser(detailCommon.overview)}
          </p>
          {
            contentType !='course' ?
            <Quote
              textClassName={classes.quoteText}
              text={ReactHtmlParser((detailCommon.zipcode ? "("+detailCommon.zipcode+")" : "") + (detailCommon.addr1 ? detailCommon.addr1+"<br />" : "") + (detailCommon.tel ? detailCommon.tel+"<br />" : "") + (detailCommon.homepage ? detailCommon.homepage+"<br />" : "")) }
            />
            :
            null
          }
          {
            isMobile ?
              <AdInFeed currentPath={currentPath+"/4904134593"} slot="4904134593" layoutKey="-fu+69-1o-ce+so" />
            :
              <AdInFeed currentPath={currentPath+"/4527648506"} slot="4527648506" layoutKey="-gs+d+5c-9-3e" />
          }

          <h3 className={classes.contentsSubTitle} style={{marginTop:"50px"}}>
            <b>{i18n.t('detailUtilizationInformation')}</b>
          </h3>
          <hr></hr>
          <p style={{ fontWeight:"400"}}>
          {
            contentType =='travel' ?   
            <>
            {detailIntro.infocenter ? (<><b>{i18n.t('detailInformation')} : </b>{ReactHtmlParser(detailIntro.infocenter)}<br /><br /></>) : null}
            {detailIntro.accomcount ? (<><b>{i18n.t('detailAccomcount')} : </b>{ReactHtmlParser( detailIntro.accomcount )}<br /><br /></>) : null}
            {detailIntro.expagerange ? (<><b>{i18n.t('detailExpagerange')} : </b>{ReactHtmlParser( detailIntro.expagerange )}<br /><br /></>) : null}
            {detailIntro.expguide ? (<><b>{i18n.t('detailExpguide')} : </b>{ReactHtmlParser( detailIntro.expguide )}<br /><br /></>) : null}
            {detailIntro.parking ? (<><b>{i18n.t('detailParkingFacilities')} : </b>{ReactHtmlParser( detailIntro.parking )}<br /><br /></>) : null}
            {detailIntro.restdate ? (<><b>{i18n.t('detailClosed')} : </b>{ReactHtmlParser( detailIntro.restdate )}<br /><br /></>) : null}
            {detailIntro.usetime ? (<><b>{i18n.t('detailOperatingHours')} : </b>{ReactHtmlParser( detailIntro.usetime )}<br /><br /></>) : null}
            </>
            :  contentType =='culture' ? 
            <>
            {detailIntro.infocenterculture ? (<><b>{i18n.t('detailInformation')} : </b>{ReactHtmlParser(detailIntro.infocenterculture)}<br /><br /></>) : null}
            {detailIntro.parkingculture ? (<><b>{i18n.t('detailParkingFacilities')} : </b>{ReactHtmlParser( detailIntro.parkingculture )}<br /><br /></>) : null}
            {detailIntro.parkingfee ? (<><b>{i18n.t('detailParkingFee')} : </b>{ReactHtmlParser( detailIntro.parkingfee )}<br /><br /></>) : null}
            {detailIntro.restdateculture ? (<><b>{i18n.t('detailClosed')} : </b>{ReactHtmlParser( detailIntro.restdateculture )}<br /><br /></>) : null}
            {detailIntro.usetimeculture ? (<><b>{i18n.t('detailOperatingHours')} : </b>{ReactHtmlParser( detailIntro.usetimeculture )}<br /><br /></>) : null}
            {detailIntro.scale ? (<><b>{i18n.t('detailScale')} : </b>{ReactHtmlParser( detailIntro.scale )}<br /><br /></>) : null}
            {detailIntro.usefee ? (<><b>{i18n.t('detailUsefee')} : </b>{ReactHtmlParser( detailIntro.usefee )}<br /><br /></>) : null}
            </>
            :
            contentType =='food' ?   
            <>
             {detailIntro.infocenterfood ? (<><b>{i18n.t('detailInformation')} : </b>{ReactHtmlParser(detailIntro.infocenterfood)}<br /><br /></>) : null}
            {detailIntro.parkingfood ? (<><b>{i18n.t('detailParkingFacilities')} : </b>{ReactHtmlParser( detailIntro.parkingfood )}<br /><br /></>) : null}
            {detailIntro.restdatefood ? (<><b>{i18n.t('detailClosed')} : </b>{ReactHtmlParser( detailIntro.restdatefood )}<br /><br /></>) : null}
            {detailIntro.firstmenu ? (<><b>{i18n.t('detailFirstmenu')} : </b>{ReactHtmlParser( detailIntro.firstmenu )}<br /><br /></>) : null}
            {detailIntro.opentimefood ? (<><b>{i18n.t('detailOperatingHours')} : </b>{ReactHtmlParser( detailIntro.opentimefood )}<br /><br /></>) : null}
            {detailIntro.smoking ? (<><b>{i18n.t('detailSmoking')} : </b>{ReactHtmlParser( detailIntro.smoking )}<br /><br /></>) : null}
            {detailIntro.treatmenu ? (<><b>{i18n.t('detailTreatmenu')} : </b>{ReactHtmlParser( detailIntro.treatmenu )}<br /><br /></>) : null}
            </>
            :  contentType =='hotel' ? 
            <>

            {detailIntro.infocenterlodging ? (<><b>{i18n.t('detailInformation')} : </b>{ReactHtmlParser(detailIntro.infocenterlodging)}<br /><br /></>) : null}
            {detailIntro.parkinglodging ? (<><b>{i18n.t('detailParkingFacilities')} : </b>{ReactHtmlParser( detailIntro.parkinglodging )}<br /><br /></>) : null}
            {detailIntro.accomcountlodging ? (<><b>{i18n.t('detailAccomcountlodging')} : </b>{ReactHtmlParser( detailIntro.accomcountlodging )}<br /><br /></>) : null}
            {detailIntro.scalelodging ? (<><b>{i18n.t('detailScalelodging')} : </b>{ReactHtmlParser( detailIntro.scalelodging )}<br /><br /></>) : null}
            {detailIntro.roomcount ? (<><b>{i18n.t('detailRoomcount')} : </b>{ReactHtmlParser( detailIntro.roomcount )}<br /><br /></>) : null}
            {detailIntro.roomtype ? (<><b>{i18n.t('detailRoomtype')} : </b>{ReactHtmlParser( detailIntro.roomtype )}<br /><br /></>) : null}
            {detailIntro.chkcooking ? (<><b>{i18n.t('detailChkcooking')} : </b>{ReactHtmlParser( detailIntro.chkcooking )}<br /><br /></>) : null}
            {detailIntro.checkintime ? (<><b>{i18n.t('detailCheckintime')} : </b>{ReactHtmlParser( detailIntro.checkintime )}<br /><br /></>) : null}
            {detailIntro.checkouttime ? (<><b>{i18n.t('detailCheckouttime')} : </b>{ReactHtmlParser( detailIntro.checkouttime )}<br /><br /></>) : null}
            {detailIntro.reservationlodging ? (<><b>{i18n.t('detailReservationlodging')} : </b>{ReactHtmlParser( detailIntro.reservationlodging )}<br /><br /></>) : null}
            {detailIntro.foodplace ? (<><b>{i18n.t('detailFoodplace')} : </b>{ReactHtmlParser( detailIntro.foodplace )}<br /><br /></>) : null}
            {detailIntro.subfacility ? (<><b>{i18n.t('detailSubfacility')} : </b>{ReactHtmlParser( detailIntro.subfacility )}<br /><br /></>) : null}

   
            </>
            :  contentType =='shopping' ? 
            <>
            {detailIntro.infocentershopping ? (<><b>{i18n.t('detailInformation')} : </b>{ReactHtmlParser( detailIntro.infocentershopping )}<br /><br /></>) : null}
            {detailIntro.parkingshopping ? (<><b>{i18n.t('detailParkingFacilities')} : </b>{ReactHtmlParser( detailIntro.parkingshopping )}<br /><br /></>) : null}
            {detailIntro.opentime ? (<><b>{i18n.t('detailOperatingHours')} : </b>{ReactHtmlParser( detailIntro.opentime )}<br /><br /></>) : null}
            {detailIntro.restdateshopping ? (<><b>{i18n.t('detailClosed')} : </b>{ReactHtmlParser( detailIntro.restdateshopping )}<br /><br /></>) : null}
            {detailIntro.scaleshopping ? (<><b>{i18n.t('detailScaleshopping')} : </b>{ReactHtmlParser( detailIntro.scaleshopping )}<br /><br /></>) : null}
            {detailIntro.saleitem ? (<><b>{i18n.t('detailSaleitem')} : </b>{ReactHtmlParser( detailIntro.saleitem )}<br /><br /></>) : null}
            {detailIntro.restroom ? (<><b>{i18n.t('detailRestroom')} : </b>{ReactHtmlParser( detailIntro.restroom )}<br /><br /></>) : null}
            {detailIntro.shopguide ? (<><b>{i18n.t('detailShopguide')} : </b>{ReactHtmlParser( detailIntro.shopguide )}<br /><br /></>) : null}
            </>
            :  contentType =='festival' ? 
            <>
              {detailIntro.sponsor1 ? (<><b>{i18n.t('detailSponsor1')} : </b>{ReactHtmlParser( detailIntro.sponsor1 )}<br /><br /></>) : null}
              {detailIntro.sponsor1tel ? (<><b>{i18n.t('detailSponsor1tel')} : </b>{ReactHtmlParser( detailIntro.sponsor1tel )}<br /><br /></>) : null}
              {detailIntro.sponsor2 ? (<><b>{i18n.t('detailSponsor2')} : </b>{ReactHtmlParser( detailIntro.sponsor2 )}<br /><br /></>) : null}
              {detailIntro.sponsor2tel ? (<><b>{i18n.t('detailSponsor2tel')} : </b>{ReactHtmlParser( detailIntro.sponsor2tel )}<br /><br /></>) : null}
              {detailIntro.eventstartdate ? (<><b>{i18n.t('detailEventstartdate')} : </b>{ReactHtmlParser( detailIntro.eventstartdate )}<br /><br /></>) : null}
              {detailIntro.eventenddate ? (<><b>{i18n.t('detailEventenddate')} : </b>{ReactHtmlParser( detailIntro.eventenddate )}<br /><br /></>) : null}
              {detailIntro.playtime ? (<><b>{i18n.t('detailPlaytime')} : </b>{ReactHtmlParser( detailIntro.playtime )}<br /><br /></>) : null}
              {detailIntro.eventplace ? (<><b>{i18n.t('detailEventplace')} : </b>{ReactHtmlParser( detailIntro.eventplace )}<br /><br /></>) : null}
              {detailIntro.usetimefestival ? (<><b>{i18n.t('detailUsetimefestival')} : </b>{ReactHtmlParser( detailIntro.usetimefestival )}<br /><br /></>) : null}
              {detailIntro.discountinfofestival ? (<><b>{i18n.t('detailDiscountinfofestival')} : </b>{ReactHtmlParser( detailIntro.discountinfofestival )}<br /><br /></>) : null}
              {detailIntro.agelimit ? (<><b>{i18n.t('detailAgelimit')} : </b>{ReactHtmlParser( detailIntro.agelimit )}<br /><br /></>) : null}
              {detailIntro.bookingplace ? (<><b>{i18n.t('detailBookingplace')} : </b>{ReactHtmlParser( detailIntro.bookingplace )}<br /><br /></>) : null}
              {detailIntro.placeinfo ? (<><b>{i18n.t('detailPlaceinfo')} : </b>{ReactHtmlParser( detailIntro.placeinfo )}<br /><br /></>) : null}
            </>
            :  contentType =='leisure' ? 
            <>
              {detailIntro.infocenterleports ? (<><b>{i18n.t('detailInformation')} : </b>{ReactHtmlParser( detailIntro.infocenterleports )}<br /><br /></>) : null}
              {detailIntro.usetimeleports ? (<><b>{i18n.t('detailOperatingHours')} : </b>{ReactHtmlParser( detailIntro.usetimeleports )}<br /><br /></>) : null}
              {detailIntro.restdateleports ? (<><b>{i18n.t('detailClosed')} : </b>{ReactHtmlParser( detailIntro.restdateleports )}<br /><br /></>) : null}
              {detailIntro.openperiod ? (<><b>{i18n.t('detailOpenperiod')} : </b>{ReactHtmlParser( detailIntro.openperiod )}<br /><br /></>) : null}
              {detailIntro.reservation ? (<><b>{i18n.t('detailReservationlodging')} : </b>{ReactHtmlParser( detailIntro.reservation )}<br /><br /></>) : null}
              {detailIntro.usefeeleports ? (<><b>{i18n.t('detailUsefeeleports')} : </b>{ReactHtmlParser( detailIntro.usefeeleports )}<br /><br /></>) : null}
              {detailIntro.expagerangeleports ? (<><b>{i18n.t('detailExpagerange')} : </b>{ReactHtmlParser( detailIntro.expagerangeleports )}<br /><br /></>) : null}
              {detailIntro.parkingleports ? (<><b>{i18n.t('detailParkingFacilities')} : </b>{ReactHtmlParser( detailIntro.parkingleports )}<br /><br /></>) : null}
              {detailIntro.parkingfeeleports ? (<><b>{i18n.t('detailParkingFee')} : </b>{ReactHtmlParser( detailIntro.parkingfeeleports )}<br /><br /></>) : null}
            </>
            :  contentType =='transportation' ? 
            <>
            {detailIntro.infocentertraffic ? (<><b>{i18n.t('detailInformation')} : </b>{ReactHtmlParser( detailIntro.infocentertraffic )}<br /><br /></>) : null}
            {detailIntro.foreignerinfocenter ? (<><b>{i18n.t('detailForeignerinfocenter')} : </b>{ReactHtmlParser( detailIntro.foreignerinfocenter )}<br /><br /></>) : null}
            {detailIntro.chkcreditcardtraffic ? (<><b>{i18n.t('detailChkcreditcardtraffic')} : </b>{ReactHtmlParser( detailIntro.chkcreditcardtraffic )}<br /><br /></>) : null}
            {detailIntro.conven ? (<><b>{i18n.t('detailConven')} : </b>{ReactHtmlParser( detailIntro.conven )}<br /><br /></>) : null}
            {detailIntro.disablefacility ? (<><b>{i18n.t('detailDisablefacility')} : </b>{ReactHtmlParser( detailIntro.disablefacility )}<br /><br /></>) : null}
            {detailIntro.mainroute ? (<><b>{i18n.t('detailMainroute')} : </b>{ReactHtmlParser( detailIntro.mainroute )}<br /><br /></>) : null}
            {detailIntro.operationtimetraffic ? (<><b>{i18n.t('detailOperationtime')} : </b>{ReactHtmlParser( detailIntro.operationtimetraffic )}<br /><br /></>) : null}
            {detailIntro.parkingtraffic ? (<><b>{i18n.t('detailParkingFacilities')} : </b>{ReactHtmlParser( detailIntro.parkingtraffic )}<br /><br /></>) : null}
            {detailIntro.restroomtraffic ? (<><b>{i18n.t('detailRestroom')} : </b>{ReactHtmlParser( detailIntro.restroomtraffic )}<br /><br /></>) : null}
            {detailIntro.shipinfo ? (<><b>{i18n.t('detailShipinfo')} : </b>{ReactHtmlParser( detailIntro.shipinfo )}<br /><br /></>) : null}
            </>
            :  contentType =='course' ? 
            <>
            {detailIntro.distance ? (<><b>총 거리 : </b>{ReactHtmlParser( detailIntro.distance )}<br /><br /></>) : null}
            {detailIntro.taketime ? (<><b>소요 시간 : </b>{ReactHtmlParser( detailIntro.taketime )}<br /><br /></>) : null}
           
            </>
            :
            ""
          }
          
          {  contentType !='hotel' &&detailInfos && detailInfos.length >0?
              detailInfos.map(
                detailInfo => ( 
                  detailInfo.infotext !="" ?
                    contentType !='course' ?
                      <div key={detailInfo.serialnum} >
                        <h3 className={classes.contentsSubTitle} style={{marginTop:"50px"}}>
                          <b>{detailInfo.infoname}</b>
                        </h3>
                        <hr></hr>
                      {ReactHtmlParser(detailInfo.infotext)}
                      </div>
                    :
                      <div key={detailInfo.subcontentid} >
                        <h3 className={classes.contentsSubTitle} style={{marginTop:"50px"}}>
                          <b>{detailInfo.subnum +1} 코스 : {detailInfo.subname}</b>
                        </h3>
                        <hr></hr>
                        {detailInfo.subdetailimg ? <GridItem xs={12} sm={12} md={12}><img style={{width:"100%"}} src={`${detailInfo.subdetailimg.replace('http:', 'https:')}`} alt={detailInfo.subname}></img></GridItem> : null }
                        {ReactHtmlParser(detailInfo.subdetailoverview)}
                      </div>
                  :null
                )
              )
              :  contentType !='hotel' && detailInfos  ?
                detailInfos.infotext != "" ?
                  contentType !='course' ?
                    <div key={detailInfos.serialnum} >
                      <h3 className={classes.contentsSubTitle} style={{marginTop:"50px"}}>
                        <b>{detailInfos.infoname}</b>
                      </h3>
                      <hr></hr>
                      {ReactHtmlParser(detailInfos.infotext)}
                    </div>
                  :
                    <div key={detailInfos.subcontentid} >
                      <h3 className={classes.contentsSubTitle} style={{marginTop:"50px"}}>
                        <b>{detailInfos.subname}</b>
                      </h3>
                      <hr></hr>
                      {detailInfos.subdetailimg ? <GridItem xs={12} sm={12} md={12}><img style={{width:"100%"}} src={`${detailInfos.subdetailimg.replace('http:', 'https:')}`} alt={detailInfos.subname}></img></GridItem> : null }
                      {ReactHtmlParser(detailInfos.subdetailoverview)}
                    </div>
                : null
            : null
          }

        {
          detailCommon.directions ?
          <>
              <h3 className={classes.contentsSubTitle} style={{marginTop:"50px"}}>
              <b>{i18n.t('detailAccess')}</b>
              </h3>
              <hr></hr>
              {ReactHtmlParser(detailCommon.directions)}
          </>
                 :
                 ""
        }
        </p>
        {
          isMobile ?
            <AdInFeed currentPath={currentPath+"/9156324500"} slot="9156324500" layoutKey="-6t+ed+2i-1n-4w" />
          :
            <AdInFeed currentPath={currentPath+"/6851108253"} slot="6851108253" layoutKey="-gs+g+7v-1q-6r" />
        }
        </GridItem>
        <GridItem xs={12} sm={12} md={8} style={{marginBottom:"100px"}}>
          <h3 className={classes.contentsSubTitle} style={{marginTop:"20px"}}>
            <b>{i18n.t('detailRecommend')}</b>
          </h3>
          <hr></hr>
          {
            recommendTravelList && recommendTravelList.length >0?
            <>
            <h4 style={{fontSize:"17px"}}>
              <b>{i18n.t('navTravel')}</b>
            </h4>
            <GridContainer>
            {
                recommendTravelList.map((content => content.contentid != detailCommon.contentid && (<RecommendContentsItem  key={content.contentid} content={content} lang={lang} /> )))
            }
            </GridContainer>
            </>
            : null
          }
           {
            recommendFoodList && recommendFoodList.length >0?
            <>
            <h4 style={{fontSize:"17px"}}>
              <b>{i18n.t('navFood')}</b>
            </h4>
            <GridContainer>
            {
                recommendFoodList.map((content => content.contentid != detailCommon.contentid && (<RecommendContentsItem  key={content.contentid} content={content} lang={lang} /> )))
            }
            </GridContainer>
            </>
            : null
          }
           {
            recommendHotelList && recommendHotelList.length >0?
            <>
            <h4 style={{fontSize:"17px"}}>
              <b>{i18n.t('navHotel')}</b>
            </h4>
            <GridContainer>
            {
                recommendHotelList.map((content => content.contentid != detailCommon.contentid && (<RecommendContentsItem  key={content.contentid} content={content} lang={lang} /> )))
            }
            </GridContainer>
            </>
            : null
          }
        </GridItem>
      </GridContainer>
    </div>
  );
});
export default withTranslation()(SectionText);